interface MemberProfileModalProps {
  memberName: string;
  memberInstrument: string;
  memberExperience: string;
  onClose: () => void;
}

const MemberProfileModal = ({
  memberName,
  memberInstrument,
  memberExperience,
  onClose,
}: MemberProfileModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="gradient-bg text-white p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-white text-xl font-bold mr-4">
                {memberName.slice(0, 2)}
              </div>
              <div>
                <h2 className="text-xl font-semibold">{memberName}</h2>
                <p className="opacity-90">
                  {memberInstrument} • 経験{memberExperience}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🎵</span>
                演奏楽器・スキル
              </h3>
              <div className="flex flex-wrap gap-2">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                  ドラム
                </span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
                  パーカッション
                </span>
                <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm">
                  キーボード
                </span>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🎸</span>
                好きなジャンル
              </h3>
              <div className="flex flex-wrap gap-2">
                <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">
                  ロック
                </span>
                <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">
                  ポップス
                </span>
                <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm">
                  メタル
                </span>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">📍</span>
                基本情報
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>活動エリア</span>
                  <span className="font-medium">東京都、神奈川県</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>希望活動頻度</span>
                  <span className="font-medium">週1-2回</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>バンド歴</span>
                  <span className="font-medium">{memberExperience}</span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🏆</span>
                主な実績
              </h3>
              <div className="space-y-2">
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                  <div className="flex items-center">
                    <span className="text-yellow-600 mr-2">🏆</span>
                    <div>
                      <div className="font-medium text-sm">
                        渋谷ロックフェス2023
                      </div>
                      <div className="text-xs text-gray-600">
                        The Rockersで出演
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                  <div className="flex items-center">
                    <span className="text-blue-600 mr-2">🎵</span>
                    <div>
                      <div className="font-medium text-sm">
                        オリジナル楽曲制作
                      </div>
                      <div className="text-xs text-gray-600">
                        作詞・作曲・編曲経験あり
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">💬</span>
                自己紹介
              </h3>
              <p className="text-gray-700 bg-gray-50 p-3 rounded-lg text-sm">
                ドラム歴10年です。ロックを中心に様々なジャンルを演奏してきました。現在2つのバンドで活動中で、ライブ経験も豊富です。音楽を通じて多くの人とつながりたいと思っています。
              </p>
            </div>
          </div>

          <div className="flex space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              閉じる
            </button>
            <button className="flex-1 gradient-bg text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity">
              メッセージを送る
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberProfileModal;
